"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NeChalkRivers_exports = {};
__export(NeChalkRivers_exports, {
  NeChalkRivers: () => NeChalkRivers,
  proposedChalkRiversModificationsLayer: () => proposedChalkRiversModificationsLayer,
  publishedChalkRiversLayer: () => publishedChalkRiversLayer
});
module.exports = __toCommonJS(NeChalkRivers_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_types = require("@cartographerio/types");
var import_core = require("../../core/index.js");
function publishedChalkRiversLayer(layerId, title, highCertaintyMarker, lowCertaintyMarker) {
  return (0, import_topo_map.lineLayer)({
    layerId,
    title,
    source: (0, import_topo_map.remoteTileSource)({
      url: "mapbox://cartographerio.ne_chalk_rivers_processed",
      sourceLayer: "default",
      attribution: [
        (0, import_topo_map.standardAttribution)({
          what: "Provisional Chalk Rivers Data",
          who: "Natural England",
          from: "June 2020",
          url: "https://priorityhabitats.org"
        })
      ]
    }),
    attributes: [
      (0, import_topo_map.attributeGroup)({
        attributes: [
          (0, import_topo_map.stringAttr)({
            attributeId: "highOnly",
            propertyName: "category",
            label: "High Certainty Only",
            buckets: (0, import_topo_map.standardBuckets)([(0, import_topo_map.lookupBucket)("H", highCertaintyMarker, "High Certainty")]),
            showDistribution: false
          }),
          // stringAttr({
          //   attributeId: "lowOnly",
          //   propertyName: "category",
          //   label: "Low Certainty Only",
          //   buckets: standardBuckets([
          //     lookupBucket("L", lowCertaintyMarker, "Low Certainty"),
          //   ]),
          //   showDistribution: false,
          // }),
          (0, import_topo_map.stringAttr)({
            attributeId: "highAndLow",
            propertyName: "category",
            label: "All Certainties",
            buckets: (0, import_topo_map.standardBuckets)([
              (0, import_topo_map.lookupBucket)("H", highCertaintyMarker, "High Certainty"),
              (0, import_topo_map.lookupBucket)("L", lowCertaintyMarker, "Low Certainty")
            ]),
            showDistribution: false
          })
        ]
      })
    ]
  });
}
const proposedChalkRiversModificationsLayer = (0, import_topo_map.lineLayer)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neChalkRivers"),
  title: "Proposed Chalk Rivers Additions/Deletions",
  source: (0, import_core.cartographerSourceWithDefaults)({
    layerId: (0, import_topo_map.unsafeMapLayerId)("neChalkRivers"),
    simplifyZoom: 10,
    attribution: []
  }),
  attributes: [
    (0, import_topo_map.attributeGroup)({
      attributes: [
        (0, import_topo_map.stringAttr)({
          attributeId: "modification",
          label: "Modification Type",
          buckets: (0, import_topo_map.standardBuckets)([
            (0, import_topo_map.lookupBucket)("Addition", import_topo_map.marker.quality(0.75)),
            (0, import_topo_map.lookupBucket)("Deletion", import_topo_map.marker.quality(0.35))
          ])
        })
      ]
    })
  ]
});
const NeChalkRivers = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("neChalkRivers"),
  title: "Chalk Rivers",
  defaultBase: import_types.MapBaseEnum.Satellite,
  layers: [
    publishedChalkRiversLayer(
      (0, import_topo_map.unsafeMapLayerId)("chalkRivers"),
      "Published Chalk Rivers Map",
      import_topo_map.marker.fromColor("hsl(300, 100%, 70%)"),
      import_topo_map.marker.fromColor("hsl(300, 100%, 40%)")
    ),
    proposedChalkRiversModificationsLayer
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  NeChalkRivers,
  proposedChalkRiversModificationsLayer,
  publishedChalkRiversLayer
});
//# sourceMappingURL=NeChalkRivers.js.map
